var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCostCodeBarCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.94 32.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.98,
    height: 32.54
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.64,
    width: 6.51,
    height: 32.54
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.53,
    width: 2.74,
    height: 32.54
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.92,
    width: 3.98,
    height: 32.54
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.56,
    width: 8.38,
    height: 32.54
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.96,
    width: 3.98,
    height: 32.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostCodeBarCode);
export default __webpack_public_path__ + "static/media/cost_code_bar_code.cdac1bcf13569618e53d8b44c4658ef1.svg";
export { ForwardRef as ReactComponent };